// @flow

const isUserARepresentative = (columns: any) => {
  return columns && columns.length && !columns.some(i => i.Rep === '');
};

export { isUserARepresentative };
